import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { theme } from '../common/theme';
import { IconName } from '../te-icon';
import { TeButtonBase } from './te-button-base';
import '../te-spacing';
import '../te-text';

/** Squared Button Component */
@customElement('te-button-squared')
export class TeButtonSquared extends TeButtonBase {
  static styles = [
    ...TeButtonBase.styles,
    css`
      button {
        padding: 0px;
        justify-content: center;
      }
    `,
  ];

  /** Icon name from icon pack */
  @property({ type: String }) icon?: IconName;
  /** Size of the icon */
  @property({ type: Number }) iconSize = 12;
  /** Color for icon svg */
  @property({ type: String }) iconColor = theme.colors.text.toString();
  /** Hovering color for icon svg */
  @property({ type: String }) iconHoverColor = theme.colors.text.toString();

  getBackgroundColor() {
    return this.backgroundColor || theme.colors.shade0.toString();
  }

  renderIcon() {
    if (!this.icon) return;
    const color = this.hovered ? this.iconHoverColor : this.iconColor;
    return html`
      <te-icon name=${this.icon} size=${this.iconSize} color=${color} wrapperSize="1"></te-icon>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-button-squared': TeButtonSquared;
  }
}
